import { useEffect, useState } from 'react';

const navLinks = [
  { label: '今日更新', href: '#today' },
  { label: '热门影片', href: '#hot' },
  { label: '电影大全', href: '#genres' },
  { label: '高清专区', href: '#hd' },
  { label: '经典高分', href: '#classic' },
  { label: '即将上线', href: '#upcoming' },
  { label: '观影指南', href: '#guide' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 flex items-center justify-between h-16 md:h-[72px]">
        <a href="#top" className="flex items-center gap-2.5 group">
          <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center text-background-50 shrink-0">
            <i className="ri-movie-2-fill text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading font-bold text-lg tracking-wide ${
                solid ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              西瓜影院
            </span>
            <span
              className={`text-[10px] tracking-[0.2em] mt-1 ${
                solid ? 'text-foreground-500' : 'text-background-100/80'
              }`}
            >
              WATERMELON CINEMA
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                solid
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-background-100 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#hot"
            className="ml-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            立即选片
          </a>
        </nav>

        <button
          type="button"
          aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md ${
            solid ? 'text-foreground-900' : 'text-background-50'
          }`}
        >
          <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
        </button>
      </div>

      {menuOpen && (
        <nav className="lg:hidden border-t border-background-200/70 bg-background-50 px-4 py-3 grid grid-cols-2 gap-2">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="px-3 py-2.5 rounded-md text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#hot"
            onClick={() => setMenuOpen(false)}
            className="col-span-2 px-3 py-2.5 rounded-md text-sm font-medium bg-primary-500 text-background-50 text-center hover:bg-primary-600 transition-colors"
          >
            立即选片
          </a>
        </nav>
      )}
    </header>
  );
}